import { t, tf } from "./i18n.js";
// ==========================================
// SECURE DARTS - ONLINE MULTIPLAYER
//
// Anders als 501 (feste 2 Spieler, eigene Spalten in live_matches) hat Secure
// eine variable Spielerzahl und einen gemeinsamen Zielindex. Der komplette
// Spielstand liegt deshalb als JSONB in live_secure_matches.state und wird
// nach jedem Zug vom aktiven Client geschrieben. Alle anderen hoeren per
// Realtime zu und uebernehmen den Stand.
//
// Benoetigt die Tabelle aus supabase/live_secure_matches.sql
// ==========================================

let secureRoomCode = "";
window.isSecureOnline = false;
let isSecureHost = false;
let isSecureSpectator = false; // Zuschauer: liest nur mit, schreibt nie
let mySecureSeat = -1; // Index in players[] - nur dieser Sitz darf eingeben
let secureSubscription = null;
let isApplyingSecureState = false; // verhindert Echo-Schleifen beim Sync
let secureStartTargetIndex = 0; // Startpunkt der Leiter (Kurzmodus) - fuer Revanche
let lastFinishedRoom = null; // Raumdaten des beendeten Spiels - fuer Revanche

function makeSecurePlayer(name, userId) {
  return {
    isBot: false,
    name: name,
    user_id: userId,
    score: 0,
    stats: { rounds: 0, secures: 0, doubles: 0, numberData: {} },
    matchLog: [],
  };
}

// ------------------------------------------------------------------
// HOSTEN
// ------------------------------------------------------------------
async function hostOnlineSecureGame() {
  const nameEl = document.getElementById("online-player-name-secure");
  const name = nameEl ? nameEl.value.trim() : "";
  if (!name) return showToast(t("js.g501.001"), "warning");

  const code = Math.random().toString(36).substring(2, 6).toUpperCase();
  const isPublic =
    document.getElementById("chk-is-public-secure")?.checked ?? true;
  const cameraRequired =
    document.getElementById("chk-camera-required-secure")?.checked ?? false;

  const { error } = await _supabase.from("live_secure_matches").insert([
    {
      room_code: code,
      host_name: name,
      host_user_id: !isGuest && currentUser ? currentUser.id : null,
      host_avatar: currentUser?.user_metadata?.avatar_url || null,
      status: "waiting",
      is_public: isPublic,
      camera_required: cameraRequired,
      state: {},
      last_action: t("js.secureonline.021"),
    },
  ]);

  if (error) return showToast(t("js.auth.010") + error.message, "error");

  myOnlineName = name;
  secureRoomCode = code;
  currentRoomCode = code;
  isSecureOnline = true;
  isSecureHost = true;
  isSecureSpectator = false;
  mySecureSeat = 0;
  currentAppMode = "secure";

  openSecureLobby(code, name, null, true);
  listenForSecureOpponent(code);
}

// ------------------------------------------------------------------
// BEITRETEN
// ------------------------------------------------------------------
async function joinOnlineSecureGame() {
  const nameEl = document.getElementById("online-player-name-secure");
  const name = nameEl ? nameEl.value.trim() : "";
  const codeEl = document.getElementById("join-room-code-secure");
  const code = codeEl ? codeEl.value.trim().toUpperCase() : "";

  if (!name) return showToast(t("js.g501.001"), "warning");
  if (!code) return showToast(t("js.g501.002"), "warning");

  const { data: room, error } = await _supabase
    .from("live_secure_matches")
    .select("*")
    .eq("room_code", code)
    .maybeSingle();

  if (error || !room) return showToast(t("js.g501.003"), "error");
  if (room.status !== "waiting")
    return showToast(t("js.g501.004"), "warning");
  if (room.guest_name)
    return showToast(t("js.secureonline.010"), "warning");
  if (room.host_name && room.host_name.toLowerCase() === name.toLowerCase())
    return showToast(t("js.secureonline.011"), "warning");

  const { data: claimed, error: updateError } = await _supabase
    .from("live_secure_matches")
    .update({
      guest_name: name,
      guest_user_id: !isGuest && currentUser ? currentUser.id : null,
      guest_avatar: currentUser?.user_metadata?.avatar_url || null,
      last_action: tf("js.secureonline.012", { p1: name }),
    })
    .eq("room_code", code)
    .is("guest_name", null) // verhindert, dass zwei Gaeste denselben Platz belegen
    .select("room_code");

  if (updateError)
    return showToast(t("js.secureonline.022") + updateError.message, "error");

  // FIX (Race): Wenn ein zweiter Gast Millisekunden frueher beigetreten ist,
  // trifft das Update 0 Zeilen - vorher lief der Verlierer trotzdem in die
  // Lobby und beide hielten sich fuer Sitz 1. Jetzt wird der leere Treffer
  // erkannt und sauber abgebrochen.
  if (!claimed || claimed.length === 0)
    return showToast(t("js.secureonline.010"), "warning");

  myOnlineName = name;
  secureRoomCode = code;
  currentRoomCode = code;
  isSecureOnline = true;
  isSecureHost = false;
  isSecureSpectator = false;
  mySecureSeat = 1;
  currentAppMode = "secure";

  openSecureLobby(code, room.host_name, name, false);
  listenForSecureOpponent(code);
}

// ------------------------------------------------------------------
// LOBBY
// ------------------------------------------------------------------
function openSecureLobby(code, hostName, guestName, isHost) {
  hideAllScreens();
  const lobby = document.getElementById("secure-lobby-screen");
  if (lobby) lobby.style.display = "block";

  setSecureText("secure-lobby-code", code);
  updateSecureLobbyPlayers(hostName, guestName);

  const startBtn = document.getElementById("btn-start-secure-match");
  if (startBtn) {
    startBtn.style.display = isHost ? "block" : "none";
    startBtn.disabled = !guestName;
  }

  const hint = document.getElementById("secure-lobby-hint");
  if (hint) {
    hint.textContent = isHost
      ? t("js.secureonline.001")
      : t("js.secureonline.002");
  }
}

function updateSecureLobbyPlayers(hostName, guestName) {
  setSecureText("secure-lobby-host", hostName || t("js.camera.003"));
  const guestEl = document.getElementById("secure-lobby-guest");
  if (guestEl) {
    guestEl.textContent = guestName || t("js.camera.004");
    guestEl.style.color = guestName ? "var(--text-main)" : "var(--text-muted)";
  }

  const startBtn = document.getElementById("btn-start-secure-match");
  if (startBtn && isSecureHost) {
    startBtn.disabled = !guestName;
    startBtn.style.opacity = guestName ? "1" : "0.5";
  }
}

function setSecureText(id, value) {
  const el = document.getElementById(id);
  if (el) el.textContent = value;
}

function copySecureRoomCode() {
  if (!secureRoomCode) return;
  navigator.clipboard
    ?.writeText(secureRoomCode)
    .then(() => showToast(t("js.secureonline.023"), "success"))
    .catch(() => showToast(t("js.secureonline.003"), "warning"));
}

// ------------------------------------------------------------------
// MATCH STARTEN (nur Host)
// ------------------------------------------------------------------
async function startOnlineSecureMatch() {
  if (!isSecureHost) return;

  const { data: room } = await _supabase
    .from("live_secure_matches")
    .select("*")
    .eq("room_code", secureRoomCode)
    .maybeSingle();

  if (!room || !room.guest_name)
    return showToast(t("js.secureonline.024"), "warning");

  players = [
    makeSecurePlayer(room.host_name, room.host_user_id),
    makeSecurePlayer(room.guest_name, room.guest_user_id),
  ];
  currentPlayerIndex = 0;
  // Kurzmodus (10-Bull): Der Host bestimmt die Variante; der Startindex
  // wandert ueber den State-Sync automatisch zum Gast.
  const chkShortOnline = document.getElementById("chk-short-mode-online");
  isShortMode = chkShortOnline ? chkShortOnline.checked : false;
  globalTargetIndex = isShortMode ? Math.max(0, targets.indexOf(10)) : 0;
  secureStartTargetIndex = globalTargetIndex; // fuer eine spaetere Revanche
  // Die Trainingsmarke kommt seit 15.08.2026 aus dem Modus-Register
  // (app.js, MODUS_GRUPPE) statt aus einem Haken. Secure steht unter
  // "Spielen" - online erst recht.
  setzeAppModus("secure");
  gameHistoryStack = [];

  await _supabase
    .from("live_secure_matches")
    .update({
      status: "playing",
      state: buildSecureState(),
      last_action: t("js.secureonline.025"),
    })
    .eq("room_code", secureRoomCode);

  enterSecureOnlineGame();
}

function enterSecureOnlineGame() {
  // Riegel des vorigen Spiels loesen. Er sitzt in game-secure.js und wird
  // offline von startGame() geraeumt - die Online-Revanche laeuft dort aber
  // nicht durch (startSecureRematch baut die Spieler selbst auf).
  if (typeof window.secureSpielFreigeben === "function") window.secureSpielFreigeben();
  hideAllScreens();
  const screen = document.getElementById("game-secure-screen");
  if (screen) screen.style.display = "block";
  setSecureRematchBar(false);
  resetTurnInputs();
  updateUI();
  updateSecureTurnLock();
}

// ------------------------------------------------------------------
// RECONNECT (Befund #6 aus PRUEFBERICHT_ONLINE.md)
//
// Wird von showMainApp() in app.js aufgerufen, wenn beim Login ein
// laufendes/wartendes Secure-Spiel mit dem eigenen Namen gefunden wurde -
// analog zum 501-Reconnect. Setzt Sitz und Flags neu auf und haengt sich
// wieder an den Realtime-Kanal.
// ------------------------------------------------------------------
function resumeSecureOnlineGame(room) {
  if (!room || !room.room_code) return;

  const iAmHost = room.host_name === myOnlineName;
  secureRoomCode = room.room_code;
  currentRoomCode = room.room_code;
  isSecureOnline = true;
  isSecureHost = iAmHost;
  isSecureSpectator = false;
  mySecureSeat = iAmHost ? 0 : 1;
  currentAppMode = "secure";
  // Startindex der Leiter aus dem State uebernehmen, falls vorhanden -
  // wichtig, damit eine Revanche nach Reconnect im richtigen Modus startet.
  secureStartTargetIndex = 0;

  if (room.status === "waiting") {
    openSecureLobby(room.room_code, room.host_name, room.guest_name, iAmHost);
  } else {
    hideAllScreens();
    const screen = document.getElementById("game-secure-screen");
    if (screen) screen.style.display = "block";
    setSecureRematchBar(false);
    applySecureState(room.state);
  }

  listenForSecureOpponent(room.room_code);
  showToast(t("js.secureonline.026"), "success");
}

// ------------------------------------------------------------------
// STATE SYNCHRONISATION
// ------------------------------------------------------------------
function buildSecureState() {
  return {
    players: players,
    currentPlayerIndex: currentPlayerIndex,
    globalTargetIndex: globalTargetIndex,
    updatedAt: Date.now(),
  };
}

// Wird aus nextTurn() in game-secure.js aufgerufen.
async function pushSecureState(extra = {}) {
  if (!isSecureOnline || !secureRoomCode) return;
  if (isSecureSpectator) return; // Zuschauer schreiben nie in den Raum
  if (isApplyingSecureState) return;

  const { error } = await _supabase
    .from("live_secure_matches")
    .update({ state: buildSecureState(), ...extra })
    .eq("room_code", secureRoomCode);

  if (error) showToast(t("js.secureonline.004") + error.message, "error");
}

function applySecureState(state) {
  if (!state || !Array.isArray(state.players)) return;

  isApplyingSecureState = true;
  players = state.players;
  currentPlayerIndex = state.currentPlayerIndex ?? 0;
  globalTargetIndex = state.globalTargetIndex ?? 0;
  resetTurnInputs();
  updateUI();
  updateSecureTurnLock();
  isApplyingSecureState = false;
}

// Sperrt die Eingabe, wenn ein anderer Spieler am Zug ist.
function updateSecureTurnLock() {
  if (!isSecureOnline) return;

  const myTurn = !isSecureSpectator && currentPlayerIndex === mySecureSeat;
  const panel = document.getElementById("secure-input-area");
  if (panel) {
    panel.style.opacity = myTurn ? "1" : "0.45";
    panel.style.pointerEvents = myTurn ? "auto" : "none";
  }

  const banner = document.getElementById("secure-turn-banner");
  if (banner) {
    const active = players[currentPlayerIndex];
    const activeName = active ? active.name : t("js.secureonline.013");
    banner.textContent = isSecureSpectator
      ? tf("js.secureonline.014", { p1: activeName })
      : myTurn
        ? t("js.secureonline.027")
        : tf("js.secureonline.015", { p1: activeName });
    banner.style.color = myTurn
      ? "var(--accent-green)"
      : "var(--text-muted)";
    banner.style.display = "block";
  }
}

// Zentrale Pruefung: darf dieser Client gerade werfen?
function canInputSecure() {
  if (!isSecureOnline) return true;
  return currentPlayerIndex === mySecureSeat;
}

// ------------------------------------------------------------------
// REALTIME
// ------------------------------------------------------------------
function listenForSecureOpponent(code) {
  if (secureSubscription) _supabase.removeChannel(secureSubscription);

  secureSubscription = _supabase
    .channel("secure-room-" + code)
    .on(
      "postgres_changes",
      {
        event: "UPDATE",
        schema: "public",
        table: "live_secure_matches",
        filter: `room_code=eq.${code}`,
      },
      (payload) => handleSecureRoomUpdate(payload.new),
    )
    .on(
      "postgres_changes",
      {
        event: "DELETE",
        schema: "public",
        table: "live_secure_matches",
        filter: `room_code=eq.${code}`,
      },
      () => {
        showToast(t("js.secureonline.005"), "warning");
        leaveSecureOnline();
      },
    )
    .subscribe();
}

function handleSecureRoomUpdate(room) {
  if (!room) return;

  if (room.status === "waiting") {
    updateSecureLobbyPlayers(room.host_name, room.guest_name);
    if (room.guest_name && isSecureHost) {
      showToast(tf("js.secureonline.016", { p1: room.guest_name }), "success");
    }
    return;
  }

  if (room.status === "playing") {
    const lobby = document.getElementById("secure-lobby-screen");
    const game = document.getElementById("game-secure-screen");
    // Gast wechselt beim Start automatisch in die Spielansicht.
    // Nach einer Revanche (finished -> playing) verschwindet hier auch
    // die Revanche-Leiste wieder.
    if (game && game.style.display !== "block") {
      hideAllScreens();
      game.style.display = "block";
    }
    if (lobby) lobby.style.display = "none";
    setSecureRematchBar(false);
    // Auch der Client, der NICHT ausgeloest hat, muss den Riegel loesen -
    // er kommt hier an, ohne enterSecureOnlineGame zu durchlaufen.
    if (typeof window.secureSpielFreigeben === "function") window.secureSpielFreigeben();
    applySecureState(room.state);
    return;
  }

  if (room.status === "finished") {
    // FIX (Doppel-Toast): Der Client, der das Ende selbst ausgeloest hat,
    // hat den Sieger-Toast bereits in handleGameEnd gezeigt - sein eigenes
    // Realtime-Echo wuerde ihn ein zweites Mal einblenden.
    const announcedLocally = window.secureEndAnnounced === true;
    window.secureEndAnnounced = false;

    applySecureState(room.state);
    if (!announcedLocally) {
      const winner = (room.state?.players || [])
        .slice()
        .sort((a, b) => b.score - a.score)[0];
      if (winner) {
        showToast(tf("js.secureonline.017", { p1: winner.name, p2: winner.score }), "success", 5000);
      }
    }

    // REMATCH: Verbindung und Raum bewusst NICHT abbauen. Der Endstand
    // bleibt sichtbar, die Eingabe wird gesperrt und die Revanche-Leiste
    // erscheint (Host: Startknopf, Gast: Wartetext). Zuschauer bleiben
    // einfach dran und sehen eine Revanche automatisch mit.
    lastFinishedRoom = room;
    lockSecureInputForFinish();
    if (!isSecureSpectator) setSecureRematchBar(true);
  }
}

// Eingabe nach Spielende sperren, Banner informiert
function lockSecureInputForFinish() {
  const panel = document.getElementById("secure-input-area");
  if (panel) {
    panel.style.opacity = "0.45";
    panel.style.pointerEvents = "none";
  }
  const banner = document.getElementById("secure-turn-banner");
  if (banner) {
    banner.textContent = isSecureSpectator
      ? t("js.secureonline.zuschauerEnde")
      : t("js.secureonline.028");
    banner.style.color = "var(--text-muted)";
    banner.style.display = "block";
  }
}

// ------------------------------------------------------------------
// REVANCHE
// ------------------------------------------------------------------
function setSecureRematchBar(visible) {
  const bar = document.getElementById("secure-rematch-bar");
  if (!bar) return;
  bar.style.display = visible ? "flex" : "none";
  if (!visible) return;

  const btn = document.getElementById("btn-secure-rematch");
  const text = document.getElementById("secure-rematch-text");
  if (btn) btn.style.display = isSecureHost ? "block" : "none";
  if (text) {
    text.textContent = isSecureHost
      ? t("js.secureonline.018")
      : t("js.secureonline.006");
  }
}

// Nur der Host startet die Revanche: gleicher Raum, Staende auf null,
// der Gast beginnt (Anwurfwechsel). Der Gast zieht ueber das Realtime-
// Update (finished -> playing) automatisch mit.
async function startSecureRematch() {
  if (!isSecureHost || !secureRoomCode || !lastFinishedRoom) return;

  // Der Gast kann den Raum nach dem Ende verlassen haben (guest_name wird
  // dann per Update genullt und lastFinishedRoom aktualisiert).
  if (!lastFinishedRoom.guest_name) {
    return showToast(t("js.secureonline.019"), "warning");
  }

  players = [
    makeSecurePlayer(lastFinishedRoom.host_name, lastFinishedRoom.host_user_id),
    makeSecurePlayer(lastFinishedRoom.guest_name, lastFinishedRoom.guest_user_id),
  ];
  currentPlayerIndex = 1; // Anwurfwechsel: der Gast beginnt die Revanche
  globalTargetIndex = secureStartTargetIndex;
  gameHistoryStack = [];

  const { error } = await _supabase
    .from("live_secure_matches")
    .update({
      status: "playing",
      state: buildSecureState(),
      last_action: t("js.secureonline.029"),
    })
    .eq("room_code", secureRoomCode);

  if (error) return showToast(t("js.secureonline.030") + error.message, "error");

  setSecureRematchBar(false);
  enterSecureOnlineGame();
}

// ------------------------------------------------------------------
// VERLASSEN / AUFRAEUMEN
// ------------------------------------------------------------------
async function cancelSecureOnlineGame() {
  // Zuschauer verlassen nur - sie duerfen weder den Raum loeschen noch
  // den Gast-Platz freigeben (sie besitzen keinen).
  if (isSecureSpectator) {
    leaveSecureOnline();
    return;
  }

  if (isSecureHost && secureRoomCode) {
    await _supabase
      .from("live_secure_matches")
      .delete()
      .eq("room_code", secureRoomCode);
  } else if (secureRoomCode) {
    await _supabase
      .from("live_secure_matches")
      .update({ guest_name: null, guest_user_id: null, last_action: t("js.secureonline.020") })
      .eq("room_code", secureRoomCode);
  }
  leaveSecureOnline();
}

function leaveSecureOnline(goToHome = true) {
  if (secureSubscription) {
    _supabase.removeChannel(secureSubscription);
    secureSubscription = null;
  }
  isSecureOnline = false;
  isSecureHost = false;
  isSecureSpectator = false;
  mySecureSeat = -1;
  secureRoomCode = "";
  currentRoomCode = "";
  lastFinishedRoom = null;
  players = [];
  setSecureRematchBar(false);

  const banner = document.getElementById("secure-turn-banner");
  if (banner) banner.style.display = "none";
  const panel = document.getElementById("secure-input-area");
  if (panel) {
    panel.style.opacity = "1";
    panel.style.pointerEvents = "auto";
  }

  if (goToHome) goHome();
}

// ------------------------------------------------------------------
// ZUSCHAUEN
//
// Machbar ohne Server-Aenderung: Der komplette Spielstand liegt als JSONB
// in live_secure_matches.state und jeder Realtime-Abonnent bekommt jedes
// Update. Ein Zuschauer abonniert also nur den Raum, uebernimmt den State
// und bleibt dauerhaft gesperrt (mySecureSeat = -1, isSecureSpectator).
// ------------------------------------------------------------------
async function spectateSecureGame(code) {
  if (!code) return;

  const { data: room, error } = await _supabase
    .from("live_secure_matches")
    .select("*")
    .eq("room_code", code)
    .maybeSingle();

  if (error || !room) return showToast(t("js.g501.003"), "error");
  if (room.status !== "playing")
    return showToast(t("js.secureonline.007"), "warning");

  secureRoomCode = code;
  currentRoomCode = code;
  isSecureOnline = true;
  isSecureHost = false;
  isSecureSpectator = true;
  mySecureSeat = -1; // stimmt nie mit currentPlayerIndex ueberein -> gesperrt
  currentAppMode = "secure";

  hideAllScreens();
  const screen = document.getElementById("game-secure-screen");
  if (screen) screen.style.display = "block";

  applySecureState(room.state);
  listenForSecureOpponent(code);
  showToast(t("js.secureonline.008"), "info");
}

// Offene Lobbys zum direkten Beitreten + laufende Spiele zum Zuschauen
async function loadPublicSecureLobbies() {
  const list = document.getElementById("secure-public-lobbies");
  if (!list) return;
  list.innerHTML = "";

  // Verwaiste Eintraege anderer Hosts (Tab zu, nie aufgeraeumt) ausblenden -
  // der 4h-Cleanup in showMainApp() greift nur fuer die eigenen.
  const fourHoursAgo = new Date(Date.now() - 4 * 60 * 60 * 1000).toISOString();

  const [{ data: open, error: openError }, { data: running }] =
    await Promise.all([
      _supabase
        .from("live_secure_matches")
        .select("room_code, host_name, created_at")
        .eq("status", "waiting")
        .eq("is_public", true)
        .is("guest_name", null)
        .gte("created_at", fourHoursAgo)
        .order("created_at", { ascending: false })
        .limit(10),
      _supabase
        .from("live_secure_matches")
        .select("room_code, host_name, guest_name, created_at")
        .eq("status", "playing")
        .eq("is_public", true)
        .gte("created_at", fourHoursAgo)
        .order("created_at", { ascending: false })
        .limit(10),
    ]);

  const addHeader = (text) => {
    const h = document.createElement("div");
    h.style.cssText =
      "color: var(--text-muted); font-size: 0.75em; text-transform: uppercase; letter-spacing: 1px; margin: 8px 0 4px 0;";
    h.textContent = text;
    list.appendChild(h);
  };

  const hasOpen = !openError && open && open.length > 0;
  const hasRunning = running && running.length > 0;

  if (!hasOpen && !hasRunning) {
    const empty = document.createElement("div");
    empty.style.cssText =
      "color: var(--text-muted); font-size: 0.85em; text-align: center; padding: 10px;";
    empty.textContent = t("js.secureonline.009");
    list.appendChild(empty);
    return;
  }

  if (hasOpen) {
    addHeader(t("js.secureonline.031"));
    open.forEach((room) => {
      const row = document.createElement("button");
      row.className = "lobby-row";
      row.onclick = () => {
        const codeEl = document.getElementById("join-room-code-secure");
        if (codeEl) codeEl.value = room.room_code;
        joinOnlineSecureGame();
      };

      const name = document.createElement("span");
      name.textContent = room.host_name; // textContent: Name kommt aus der DB
      const code = document.createElement("span");
      code.style.color = "var(--accent-blue)";
      code.style.fontWeight = "800";
      code.textContent = room.room_code;

      row.appendChild(name);
      row.appendChild(code);
      list.appendChild(row);
    });
  }

  if (hasRunning) {
    addHeader(t("js.secureonline.032"));
    running.forEach((room) => {
      const row = document.createElement("button");
      row.className = "lobby-row";
      row.onclick = () => spectateSecureGame(room.room_code);

      const name = document.createElement("span");
      name.textContent = tf("js.secureonline.033", { p1: room.host_name, p2: room.guest_name || "?" });
      const watch = document.createElement("span");
      watch.style.color = "var(--accent)";
      watch.style.fontWeight = "800";
      watch.textContent = t("js.secureonline.zuschauen");

      row.appendChild(name);
      row.appendChild(watch);
      list.appendChild(row);
    });
  }
}

// ---------------------------------------------------------------
// Bruecke zu window: Inline-Handler im HTML und andere Module greifen
// weiterhin global auf diese Funktionen zu. Automatisch erzeugt beim
// Umstieg auf Vite - Modul-Scope ersetzt sonst die alten Globals.
// ---------------------------------------------------------------
Object.assign(window, {
  hostOnlineSecureGame,
  joinOnlineSecureGame,
  copySecureRoomCode,
  startOnlineSecureMatch,
  pushSecureState,
  updateSecureTurnLock,
  canInputSecure,
  cancelSecureOnlineGame,
  loadPublicSecureLobbies,
  spectateSecureGame,
  resumeSecureOnlineGame,
  startSecureRematch,
});
